import React, { useState, useEffect } from "react";
import tache from "../../../assets/TACHE NOTARIA.png";
import palomita from "../../../assets/pngegg.png";
import { useintStore } from "../../zustandShared/intStore.js";

const CheckListModal = ({
  checkListOpen,
  setCheckListOpen,
  name_legalact,
  documento,
}) => {
  const [estados, setEstados] = useState([]);
  const { agregarOActualizarDocumentos, documentosGuardados } =
    useintStore();

  // Inicializamos estados desde documentosGuardados si existe, o desde documento
  useEffect(() => {
    if (!documento || documento.length === 0) return;

    const grupo = documentosGuardados.find(
      ([docsArray, hechoJuridico]) => hechoJuridico === name_legalact
    );

    if (grupo) {
      // Tomamos el array de documentos guardados
      setEstados([...grupo[0]]);
    } else {
      // Inicializamos con todos desactivados
      setEstados(
        documento.map((doc) => ({
          activar: false,
          seleccionado: false,
          archivo: doc,
        }))
      );
    }
  }, [documento, documentosGuardados, name_legalact]);
  //Si se selecciona, se desactiva el segundo checkbox
  const handleActivar = (index) => {
    const nuevos = [...estados];
    nuevos[index].activar = !nuevos[index].activar;
    if (nuevos[index].activar) nuevos[index].seleccionado = false;
    setEstados(nuevos);

    
  };
  //Segundo checkbox
  const handleSeleccionar = (index) => {
    const nuevos = [...estados];
    nuevos[index].seleccionado = !nuevos[index].seleccionado;
    setEstados(nuevos);
  };

  const guardarDocumentos = async () => {
    const estadosConvertidos = estados.map((item) => ({
      ...item,
      activar: item.activar ? 1 : 0,
      seleccionado: item.seleccionado ? 1 : 0,
    }));

    const datosGuardados = [estadosConvertidos, name_legalact];
    

    agregarOActualizarDocumentos(datosGuardados);
    //console.log("estados guardados", datosGuardados);

    try {
      //await axios.post(documentos_entregados, datosGuardados);
    } catch (error) {
      console.error("No se guardaron correctamente los documentos:", error);
    }
  };

  if (!checkListOpen) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0,0,0,0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1000,
      }}
    >
      <div
        style={{
          backgroundColor: "#fff",
          padding: "20px",
          borderRadius: "8px",
          width: "900px",
          height: "650px",
          maxWidth: "90%",
        }}
      >
        <h1>{name_legalact}</h1>
        <hr />
        <p>Instrucciones</p>

        <div style={{ position: "relative", left: "13%", top: "3%" }}>
          {estados.length > 0 ? (
            estados.map((doc, index) => (
              <div key={index} className="d-flex align-items-center mb-2">
                {/* Primer checkbox */}
                <label
                  className="me-3"
                  style={{ cursor: "pointer", display: "inline-block" }}
                >
                  <input
                    type="checkbox"
                    checked={doc.activar}
                    onChange={() => handleActivar(index)}
                    style={{ display: "none" }}
                  />
                  <img
                    src={doc.activar ? palomita : tache}
                    alt={doc.activar ? "Activado" : "Desactivado"}
                    width={24}
                    height={24}
                  />
                </label>

                {/* Segundo checkbox */}
                <input
                  type="checkbox"
                  disabled={doc.activar}
                  checked={doc.seleccionado}
                  onChange={() => handleSeleccionar(index)}
                  className="me-3"
                />


                <div style={{width: "80%"}}>

                <p
                  className="mb-0"
                  style={
                    doc.activar === true  || doc.activar === 1 ? { opacity: 0.5, color: "#777" } : {}
                  }
                >
                  {doc.archivo}
                </p>
                </div>
              </div>
            ))
          ) : (
            <p></p>
          )}
        </div>

        <button
          onClick={() => {
            setCheckListOpen(false);
            guardarDocumentos();
          }}
          className="btn btn-primary"
          style={{ position: "relative", left: "70%", top: "5%" }}
        >
          Cerrar
        </button>
      </div>
    </div>
  );
};

export default CheckListModal;
